import { getFormattedDuration } from "../../../../../../utils/dateTime/library";
import { EQUALIZER_ICON, getAudioPlayBtn } from "./constants";

const DefaultAudioUI = (props) => {
    const {
        isPlaceholderHidden,
        mediaItem,
        status,
        currentPPMediaId,
        onClick,
    } = props;
    const isPlaceholderMediaPlaying =
        status === "playing" && mediaItem.sourceId === currentPPMediaId;
    return (
        <div
            className={`player-placeholder-audio-ui ${
                isPlaceholderHidden ? "hidden" : ""
            }`}
            role="button"
            tabIndex="0"
            onKeyPress={onClick}
            onClick={onClick}
            title={mediaItem.title}
        >
            <div className={`player-placeholder-ui`}>
                <div className="play-button-container">
                    {isPlaceholderMediaPlaying
                        ? EQUALIZER_ICON
                        : getAudioPlayBtn("Play")}
                </div>

                <div className="media-thumbnail">
                    <img src={mediaItem.image?.url} alt="" loading="lazy"></img>
                </div>
                <div className="media-metadata">
                    <span className="media-showName">
                        {mediaItem.showData?.name}
                    </span>
                    <span className="media-duration">
                        {getFormattedDuration(mediaItem.media?.duration)}
                    </span>
                    <span className="media-title">{mediaItem.title}</span>
                </div>
            </div>
        </div>
    );
};

export default DefaultAudioUI;
